import { AirborneAppConfig } from "@airborne/react-admin";
import { Roles } from "./Enums/Roles";
import { OwnerType } from "./Enums/OwnerTypes";
const { version: appVersion } = require("../package.json");
// do not import any other library or function!!
export const local: AirborneAppConfig = {
  appTitle: "Pool Web Suite (v" + appVersion.split("-", 1) + ")",
  auth: {
    authority: "https://devauth.thyteknik.com.tr",
    scope: "pool",
    clientId: "PoolDev",
  },
  apiBaseUrl: "https://localhost:5001/api",
  accessum: {
    baseUrl: "https://localhost:5001/api",
    appSecret: "***REMOVED***",
    useEndpoints: true,
    version: 1,
    enforce: true,
  },
  menu: [
    {
      text: "Eight Wings",
      icon: "auto_fix_high",
      isOpen: false,
      isVisibleForCustomer: true,
      isVisibleForInternal: true,
      permissions: [Roles.Admin, Roles.EightWings],
      children: [
        {
          text: "Eight Wings List",
          path: "/eightwings/list",
          icon: "format_list_bulleted",
          isVisibleForCustomer: true,
          isVisibleForInternal: true,
          permissions: [Roles.Admin, Roles.EightWings],
        },
        {
          text: "Eight Wings TT Verify List",
          path: "/eightwingsttverify",
          icon: "format_list_bulleted",
          isVisibleForCustomer: true,
          isVisibleForInternal: true,
          permissions: [Roles.Admin],
        },
        {
          text: "Direct Delivery To FZ",
          path: "/directdeliverytofz",
          icon: "format_list_bulleted",
          isVisibleForCustomer: true,
          isVisibleForInternal: true,
          permissions: [Roles.Admin, Roles.EightWings],
        },
        {
          text: "Waiting Core Return",
          path: "/waitingcorereturn",
          icon: "format_list_bulleted",
          isVisibleForCustomer: true,
          isVisibleForInternal: true,
          permissions: [Roles.Admin, Roles.EightWings],
        },
      ],
    },
    {
      text: "PBH",
      icon: "auto_fix_high",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "PBH Dashboard",
          path: "/dashboardpbh",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
        {
          text: "PBH Request List",
          path: "/pbhrequestorders/list",
          icon: "format_list_bulleted",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "Rejected Pool Scope",
          path: "/rejectedpoolscope",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "Pbh Dafza Replenishment",
          path: "/pbhdafzareplenishment",
          icon: "merge_type",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.Customer, Roles.EightWings],
          ownersFilter: [OwnerType.AARFLYDB],
        },
        {
          text: "Pbh Cage Replenishment",
          path: "/pbhcagereplenishment",
          icon: "merge_type",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.Customer, Roles.EightWings],
          ownersFilter: [OwnerType.AARFLYDB],
        },
        {
          text: "CMS Dashboard",
          path: "/dashboardcms",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "RBH",
      icon: "auto_fix_high",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer],
      children: [
        {
          text: "RBH Dashboard",
          path: "/dashboardrbh",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer],
        },
        {
          text: "RBH Request List",
          path: "/requestorders/list",
          icon: "format_list_bulleted",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 7
          text: "Custom Pending",
          path: "/customsclearance",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //Status 9
          text: "Receipt Pending",
          path: "/initialreceiving",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 12
          text: "TT Order Pending",
          path: "/wowaitinglist",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 15
          text: "Shop",
          path: "/tobeshop",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 13
          text: "KKM",
          path: "/wwvendorprocess",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 26
          text: "Replacement Candidate",
          path: "/repairprocess",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 27
          text: "Manuel Coverage Control",
          path: "/manuelcoveragecontrol",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 22 and 24
          text: "Ongoing Repair && 	Shop Started",
          path: "/workshop",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 14
          text: "Outsource Repair",
          path: "/vendorrepair",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          //status 30
          text: "Repair Has Finished",
          path: "/dispatchwaiting",
          icon: "merge_type",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
      ],
    },
    {
      text: "CUSTOMER",
      icon: "supervised_user_circle",
      isOpen: false,
      isVisibleForCustomer: true,
      isVisibleForInternal: false,
      children: [
        {
          text: "Make New Request",
          path: "/requestorders/condition",
          icon: "add_icon",
          isVisibleForCustomer: true,
          isVisibleForInternal: false,
          unauthorizedRoles: [Roles.EightWings],
        },
        {
          //Status 1
          text: "Non Covered",
          path: "/reasoningevidence",
          icon: "merge_type",
          isVisibleForCustomer: true,
          isVisibleForInternal: false,
        },
      ],
    },
    {
      text: "HOMEBASE",
      icon: "home_work",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.EightWings],
      children: [
        {
          text: "Homebase Warehouse",
          path: "/homebasewarehouses",
          icon: "warehouse",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "AAR Storage",
          path: "/aarstorages",
          icon: "warehouse",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.EightWings],
        },
        {
          text: "Homebase Component",
          path: "/homebasecomponents",
          icon: "apps",
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
      ],
    },
    {
      text: "CORE INFO REQUEST",
      icon: "info",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Core Info Request",
          path: "/coreinforequests",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "EXCUSABLE DELAY",
      icon: "access_alarm",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Excusable RBH",
          path: "/excusable/rbh",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
        {
          text: "Excusable PBH",
          path: "/excusable/pbh",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "RELIABILITY",
      icon: "check_circle",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "EXCLUSION PN",
          path: "/reliabilityexclusionpns",
          icon: "check_circle",
          isVisibleForCustomer: false,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "FAIL ON FIT",
          path: "/failonfit",
          icon: "check_circle",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
        {
          text: "THY FAIL ON FIT",
          path: "/thyfailonfit",
          icon: "check_circle",
          isVisibleForCustomer: false,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "PREMATURE FAILURE",
          path: "/prematurefailure",
          icon: "check_circle",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
        {
          text: "THY PREMATURE FAILURE",
          path: "/thyprematurefailure",
          icon: "check_circle",
          isVisibleForCustomer: false,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "ROGUE CANDIDATE",
          path: "/rogue",
          icon: "check_circle",
          isVisibleForCustomer: false,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
        {
          text: "NFF REPORT",
          path: "/nffreport",
          icon: "check_circle",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer],
        },
        {
          text: "NFF EXCLUSION PN",
          path: "/reliabilitynffexclusionpns",
          icon: "check_circle",
          isVisibleForCustomer: false,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser],
        },
      ],
    },
    {
      text: "REPORTS",
      icon: "assessment",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Shop Report",
          path: "/shopreport",
          icon: "shop",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
        {
          text: "Local Repair Components",
          path: "/localrepaircomponents",
          icon: "build",
          permissions: [Roles.Admin],
        },
      ],
    },
    {
      text: "SEARCH",
      icon: "search",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Search",
          path: "/search",
          icon: "vertical_split_rounded",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "OLD DATA EXPORT",
      icon: "search",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Old Export Data",
          path: "/wsrequestreports",
          icon: "stream_split_rounded",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "COCKPIT",
      icon: "flight",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Cockpit",
          path: "/cockpit",
          icon: "shop",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "AIRCRAFT UTILIZATION",
      icon: "flight",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Aircraft Utilization",
          path: "/aircraftutilizations",
          icon: "language",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "AIRCRAFT MAINTENANCE",
      icon: "engineering",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
      children: [
        {
          text: "Aircraft Maintenance Schedules",
          path: "/aircraftundermaintenances",
          icon: "settings",
          isVisibleForCustomer: true,
          permissions: [Roles.Admin, Roles.RbhUser, Roles.GeneralUser, Roles.Customer, Roles.EightWings],
        },
      ],
    },
    {
      text: "ADMIN",
      icon: "admin_panel_settings",
      isOpen: false,
      isVisibleForCustomer: true,
      permissions: [Roles.Admin],
      children: [
        {
          text: "Customer",
          path: "/customers",
          icon: "group",
          permissions: [Roles.Admin],
        },
        {
          text: "Customer User",
          path: "/customerusers",
          icon: "group",
          permissions: [Roles.Admin],
        },
        {
          text: "Mail Management",
          path: "/mailmanagements",
          icon: "mail",
          permissions: [Roles.Admin],
        },
        // {
        //   text: "Flight Radar",
        //   path: "/flight-radar",
        //   icon: "flight",
        //   permissions: [Roles.Admin],
        // },
        {
          text: "FR Bulk Fetch",
          path: "/fr-bulk-fetch",
          icon: "cloud_download",
          permissions: [Roles.Admin],
        },
        {
          text: "Shipping Address",
          path: "/shippingaddresss",
          icon: "contact_mail",
          permissions: [Roles.Admin],
        },
        {
          text: "Mail Schema",
          path: "/mailschemas",
          icon: "all_inbox",
          permissions: [Roles.Admin],
        },
        // {
        //   text: 'Request Work Flow',
        //   path: '/requestworkflows',
        //   icon: 'gesture',
        //   permissions: [Roles.Admin],
        // },
        {
          text: "Experience",
          path: "/experiences",
          icon: "vertical_split_rounded",
          permissions: [Roles.Admin],
        },
        {
          text: "Status Update",
          path: "/pbhstatusupdates",
          icon: "edit",
          permissions: [Roles.Admin],
        },
        {
          text: "RBH Request Status Group",
          path: "/requeststatusgroup",
          icon: "merge_type",
          permissions: [Roles.Admin],
        },
        {
          text: "RBH Request Status Info",
          path: "/requeststatusinfos",
          icon: "merge_type",
          permissions: [Roles.Admin],
        },
        {
          text: "PBH Request Status Info",
          path: "/pbhrequeststatusinfos",
          icon: "merge_type",
          permissions: [Roles.Admin],
        },
        {
          text: "Release Types",
          path: "/releasetypes",
          icon: "gesture",
          permissions: [Roles.Admin],
        },
        {
          text: "RBH Ability Control",
          path: "/abilitycontrol",
          icon: "settings",
          permissions: [Roles.Admin],
        },
        {
          text: "Clear Cache",
          path: "/redis",
          icon: "delete",
          permissions: [Roles.Admin],
        },
        {
          text: "Test File Transfer",
          path: "/filetransfer",
          icon: "cloud_upload",
          isVisibleForCustomer: false,
          permissions: [Roles.Admin],
        },
      ],
    },
  ],
};

export const development: AirborneAppConfig = {
  ...local,
  appTitle: local.appTitle,
  auth: {
    authority: "https://devauth.thyteknik.com.tr",
    scope: "pool",
    clientId: "PoolDev",
  },
  accessum: {
    baseUrl: "https://devapi.turkishtechnic.com/pool/api",
    appSecret: "***REMOVED***",
    useEndpoints: true,
    version: 1,
    enforce: true,
  },
  apiBaseUrl: "https://devapi.turkishtechnic.com/pool/api",
  accessControl: local.accessControl,
  menu: local.menu,
};
export const test: AirborneAppConfig = {
  ...development,
  appTitle: local.appTitle,
  auth: {
    authority: "https://auth.thyteknik.com.tr",
    scope: "pool",
    clientId: "Pool",
  },
  accessum: {
    baseUrl: "https://testapi.turkishtechnic.com/pool/api",
    appSecret: "***REMOVED***",
    useEndpoints: true,
    enforce: true,
  },
  apiBaseUrl: "https://testapi.turkishtechnic.com/pool/api",
  accessControl: local.accessControl,
  menu: local.menu,
};
export const production: AirborneAppConfig = {
  // you can override values from `development` here
  ...development,
  appTitle: local.appTitle,
  auth: {
    authority: "https://auth.thyteknik.com.tr",
    scope: "pool",
    clientId: "Pool",
  },
  accessum: {
    baseUrl: "https://api.turkishtechnic.com/pool/api",
    appSecret: "***REMOVED***",
    useEndpoints: true,
    enforce: true,
  },
  apiBaseUrl: "https://api.turkishtechnic.com/pool/api",
  accessControl: local.accessControl,
  menu: local.menu,
};
